import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames, d as EGDSContextProvider } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-scrim.css';
import { v as validatePropType } from '../validate-prop-types/index-chunk.esm.js';

const EGDSScrimType = {
    OVERLAY: 'overlay',
    BOTTOM: 'fade-bottom',
    LEADING: 'fade-leading',
    TRAILING: 'fade-trailing',
    BUTTON: 'fade-button',
};
const EGDSScrimColorType = {
    PRIMARY: 'primary-background',
    SECONDARY: 'secondary-background',
};

const getClassNameList = classNames.bind(styles);
class EGDSScrim extends React.PureComponent {
    static displayName = 'EGDSScrim';
    static defaultProps = {
        type: EGDSScrimType.BOTTOM,
    };
    render() {
        const { tag, type, children, className, color } = this.props;
        let Tag = '';
        const isBottomScrim = type === EGDSScrimType.BOTTOM;
        const isOverlayScrim = type === EGDSScrimType.OVERLAY;
        if (tag && tag !== '') {
            Tag = tag;
        }
        else {
            Tag = 'div';
        }
        const wrapperClassNames = getClassNameList('uitk-scrim', className, {
            [`${type}`]: validatePropType(type, EGDSScrimType),
        }, {
            [`${color}`]: validatePropType(color, EGDSScrimColorType),
        });
        const contextData = {
            bottomScrimContext: isBottomScrim,
            overlayScrimContext: isOverlayScrim,
        };
        return (jsx(Tag, { className: wrapperClassNames, children: jsx(EGDSContextProvider, { config: { context: 'uitk-scrim-context', data: contextData }, children: children }) }));
    }
}

export { EGDSScrim as E, EGDSScrimType as a, EGDSScrimColorType as b };
//# sourceMappingURL=index-chunk.esm.js.map
